/**
 * The reading's own bar is not replaced by the Altar's menu (2026-10-21).
 *
 * The Altar's Keeper streams its "Get a reading / View your horoscope"
 * buttons to the same socket session as the reader's chat, as in-chat-window
 * buttons (backend reader/service/state_management/state_classes/keeper.py).
 * Its greeting is a model call, so they land a second or two after whatever
 * the page did meanwhile. Opening a reading in that window (Chris, reading
 * 4729: the Altar, then his finished reading) put them over the reading's
 * bar: no Keep talking, no Share, no Finish. Pure, so it is testable.
 */

/** The actions that make up a reading's bar (one made for yourself or a gift). */
const READING_BAR = new Set([
  'chat_about_this', 'talk_more', 'talk_pull_card', 'share_reading', 'exit_reading', 'rate_reading',
])

/**
 * The Keeper's menu: buttons that belong to no reader conversation (the
 * Keeper sends a label and an action only; every reader state stamps its
 * conversation_type on each button).
 */
export function isKeeperMenu(actions) {
  if (!Array.isArray(actions) || !actions.length) return false
  return actions.every(a => a && (!a.conversation_type || a.conversation_type === 'ALTAR'))
}

function hasReadingBar(actions) {
  return Array.isArray(actions) && actions.some(a => a && READING_BAR.has(a.action_type))
}

// A reader conversation under way: the opener, the interview, the draw.
// (DOORMAN is a Mystic's front door; the Altar as built may still take it.)
const READING_IN_PROGRESS = new Set([
  'TAROT_FUNNEL', 'INTERVIEW', 'GROUNDING', 'SELECTING_CARDS',
  'TAROT_N_CARD_DRAW', 'GAME_TAROT_4_CARDS', 'READING_CONCLUSION', 'RECEPTION', 'DRAW_DEEPER',
])

/** Chips a reader conversation in progress painted (the own opener's starters). */
function hasReaderChips(actions) {
  return Array.isArray(actions) && actions.some(a => a && READING_IN_PROGRESS.has(a.conversation_type))
}

/**
 * Should these incoming in-chat-window buttons be set aside? Only the
 * Keeper's menu, and only while a reading is on screen, its bar is showing,
 * a reader conversation's own chips are showing, or a reader conversation is
 * under way (Chris's hand test 2026-10-26 #2: "Get a reading / View your
 * horoscope" replaced the own reading's opener chips).
 */
export function keepReadingBar({ current = null, incoming = null, readingOnScreen = false, conversationState = '' } = {}) {
  if (!isKeeperMenu(incoming)) return false
  return !!readingOnScreen || hasReadingBar(current) || hasReaderChips(current)
    || READING_IN_PROGRESS.has(conversationState)
}
